import { withAuthorization } from "../../../authentication/Session/withAuthorization";
import { getAuthorizationGuard } from "../../../authentication/authorizations";
import { Role } from "@farmact/model/src/model/Role";
import { lazy } from "react";
import { DefaultPage } from "../../../structure/Page/DefaultPage/DefaultPage";

const CreditNotesSettingsPageContent = lazy(() => import("./CreditNoteSettingsPageContent"));

function CreditNotesSettingsPageInternal() {
    return (
        <DefaultPage>
            <CreditNotesSettingsPageContent />
        </DefaultPage>
    );
}

export const CreditNotesSettingsPage = withAuthorization(getAuthorizationGuard(Role.OWNER, Role.ADMIN))(
    CreditNotesSettingsPageInternal
);
